import styles from "./Header.module.scss"

import logoPng from "../../assets/images/logo.png"
import { useNavigate } from "react-router-dom"
import { PropsWithChildren, ReactNode, useState } from "react"
import arrowPng from "../../assets/images/service_arrow.png"


export default (props = {activateIdx: 0}) => {

    const {
        activateIdx
    } = props

    const navigate = useNavigate()

    const goToHome = () => {
        console.log("goToHome")
        navigate("/")
    }

    return (
        <div className={styles['header-wrapper']}>
            <div className={styles['header']}>
                <img className={styles['header__logo']} src={logoPng} onClick={goToHome}></img>
                <div className={styles['header__menus']}>
                    <div 
                        className={styles['header__menus__item']}
                    ><div onClick={() => goToHome()} >Home</div></div>
                    <div className={styles['header__menus__item']}>
                        <Popup render={<ServicePanel/>}>
                            <div style={{display: "flex", alignItems: "center", gap: 10}}>
                            Service<img src={arrowPng}/>
                            </div>
                        </Popup>
                    </div>
                    <div className={[styles['header__menus__item'], activateIdx == 2?styles['header__menus__item_hl']:''].join(" ")}><a href="mailto: jenny.liu@excelluslaw.com" className={styles['header__menus__item__a']}>Contact</a></div>
                </div>
            </div>
        </div>
    )
}

const Popup = (props: PropsWithChildren<{render: ReactNode}>) => {

    const [activate, setActivate] = useState(false)

    return (
        <div className={styles["popup"]}>
            <div className="" onClick={() => setActivate(!activate)}>{props.children}</div>
            {
                activate && <div className={styles["popup__box"]}>
                    {props.render}
                </div>
            }
        </div>
    )
}

const ServicePanel = () => {

    const navigate = useNavigate()

    const gotoService = (idx: number) => [
        navigate(`/service/${idx}`)
    ]

    return (
        <div className={styles["service-box"]}>
            <div className={styles["service-panel"]}>
                <div className={styles["service-panel__title"]}>
                Immigration 
                </div>
                <div className={styles["service-panel__ul"]}>
                    <div className={styles['service-panel__li']} onClick={() => gotoService(0)}>
                        Employment-based immigration
                    </div>
                    <div className={styles['service-panel__li']} onClick={() => gotoService(1)}>
                    Family-based immigration 
                    </div>
                    <div className={styles['service-panel__li']} onClick={() => gotoService(2)}>
                    Investor visas
                    </div>
                    <div className={styles['service-panel__li']} onClick={() => gotoService(3)}>
                    Student and visitor visas
                    </div>
                    <div className={styles['service-panel__li']} onClick={() => gotoService(4)}>
                    Naturalization and citizenship
                    </div>
                </div>
            </div>
            <div className={styles["service-panel"]}>
                    <div className={styles["service-panel__title"]}>
                    Other
                    </div>
                    <div className={styles["service-panel__ul"]}>
                        <div className={styles['service-panel__li']} onClick={() => gotoService(5)}>
                        Litigation and appeals
                        </div>
                        <div className={styles['service-panel__li']} onClick={() => gotoService(6)}>
                        Contracts and trademark
                        </div>
                    </div>
            </div>
        </div>
    )
}

